// extracted by mini-css-extract-plugin
module.exports = {"root":"_2RMJ_wZ-pwL8srLtMm3Tf7","content":"_3KOC6PTNtABQZtVEE_7Toz"};